//For quite some time the env files were flat & AppSettings was a way to make the
//configuration nicer to use. The env files have slowly been refactored to 
//group configuration with parent/child relationship. 
//Potentially there could be no need for AppSettings in the future.
import environment from "@environment";
import parseFeatures from "core/features/parse-features";
import UrlUtils from "core/lib/url-utils";

const isEnabled = (value: any) => value?.toString() === "true";

const appSettings = {
    isEnabled: {
        companySwitching: isEnabled(environment.ALLOW_COMPANY_SWITCHING),
        logToConsole: isEnabled(environment.LOGGING.TO_CONSOLE),
        logErrorsToDatabase: isEnabled(environment.LOGGING.TO_DATABASE),
        logToLocalStorage: isEnabled(environment.LOGGING.TO_LOCAL_STORAGE),
        logAllResponsesToDatabase: isEnabled(environment.LOGGING.ALL_RESPONSES),
        fieldTrials: isEnabled(environment.IS_FIELD_TRIALS),
        payments: isEnabled(environment.PAYMENT.ENABLED),
        paymentsShowCredit: isEnabled(environment.PAYMENT.SHOW_CREDIT),
        paymentsUseBalance: isEnabled(environment.PAYMENT.USE_BALANCE),
        headerAndFooter: isEnabled(environment.RENDER_HEADER_AND_FOOTER),
        playground: isEnabled(environment.ALLOW_DEMOS),
        tools: isEnabled(environment.ALLOW_TOOLS),
        userTracking: isEnabled(environment.USER_TRACKING_ENABLED),
        forceUserNames: isEnabled(environment.REQUIRE_USER_NAMES),
        overPaying: isEnabled(environment.PAYMENT.OVERPAYING_ENABLED),
        inbox: isEnabled(environment.INBOX_ENABLED)
    },
    connect: {
        redirectUrl: UrlUtils.parseUrl(environment.CONNECT.RETURN_URL),
        proxyUrl: environment.CONNECT.PROXY_URL,
        clientId: environment.CONNECT.CLIENT_ID,
        baseUrl: environment.CONNECT.BASE_URL,
        verifyEndpoint: environment.CONNECT.VERIFY_ENDPOINT,
    },
    urls: {
        utilityService: environment.DSTV_UTILITY_SERVICE,
        dashboard: UrlUtils.parseUrl(environment.DASHBOARD_URL),
        homePage: UrlUtils.parseUrl(environment.HOME_PAGE_URL),
        acceptChildInvite: UrlUtils.parseUrl(environment.CHILD_ACCEPT_INVITE_URL),
        umbracoApi: environment.UMBRACO_API_URL,
        payment: {
            success: UrlUtils.parseUrl(environment.PAYMENT.SUCCESS_URL),
            failed: UrlUtils.parseUrl(environment.PAYMENT.FAILURE_URL),
            cancelled: UrlUtils.parseUrl(environment.PAYMENT.CANCELLED_URL)
        },
        mahPayment: {
            result: UrlUtils.parseUrl(environment.PAYMENT.MAH_RESULT_URL),
            success: UrlUtils.parseUrl(environment.PAYMENT.MAH_SUCCESS_URL),
            failed: UrlUtils.parseUrl(environment.PAYMENT.MAH_FAILURE_URL)
        }
    },
    signalR: {
        timeout: {
            permissions: {
                data: environment.PERMISSION_DATA_TIMEOUT
            }
        }
    },
    clearError: {
        filter: environment.CLEAR_ERROR_FILTER
    },
    freshDesk: {
        groupId: parseInt(environment.FRESHDESK_GROUP_ID),
    },
    autoSelectAccounts: environment.AUTO_SELECT_ACCOUNTS,
    defaultLanguage: environment.DEFAULT_LANGUAGE,
    rootPath: environment.ROOT_PATH,
    assetsUrl: `${environment.SOURCE_FOLDER}assets/`,
    countryOverrides: {
        "bw": { disabled: parseFeatures(environment.DISABLED_FEATURES.BW) },
        "et": { disabled: parseFeatures(environment.DISABLED_FEATURES.ET) },
        "gh": { disabled: parseFeatures(environment.DISABLED_FEATURES.GH) },
        "ke": { disabled: parseFeatures(environment.DISABLED_FEATURES.KE) },
        "mw": { disabled: parseFeatures(environment.DISABLED_FEATURES.MW) },
        "mz": { disabled: parseFeatures(environment.DISABLED_FEATURES.MZ) },
        "na": { disabled: parseFeatures(environment.DISABLED_FEATURES.NA) },
        "ng": { disabled: parseFeatures(environment.DISABLED_FEATURES.NG) },
        "tz": { disabled: parseFeatures(environment.DISABLED_FEATURES.TZ) },
        "ug": { disabled: parseFeatures(environment.DISABLED_FEATURES.UG) },
        "za": { disabled: parseFeatures(environment.DISABLED_FEATURES.ZA) },
        "zm": { disabled: parseFeatures(environment.DISABLED_FEATURES.ZM) },
        "zw": { disabled: parseFeatures(environment.DISABLED_FEATURES.ZW) }
    },
    senderIds: environment.SENDER_IDS,
    apiGateway: {
        url: environment.API_GATEWAY.URL,
        key: environment.API_GATEWAY.KEY
    }
};

export default appSettings;
